/**
 * Syria Region Data
 * Comprehensive data for the Syrian Arab Republic
 */

import { Region } from "../../types/regions";

/**
 * Syria region with current borders
 */
export const SYRIA_REGION: Region = {
  id: "region-syria",
  code: "syria",
  name: "Syria",
  localizedNames: {
    en: "Syria",
    fa: "سوریه",
    ar: "سوريا",
    ku: "Sûriye",
    tr: "Suriye",
    fr: "Syrie",
  },
  description: "Syria, located in Western Asia on the eastern coast of the Mediterranean Sea",
  // Border data is loaded from src/data/borders/syria.json via getRegionBorder()

  viewport: {
    center: { lat: 34.8021, lng: 38.9968 },
    zoom: 6,
    minZoom: 5,
    maxZoom: 18,
  },

  area: 185180, // Square kilometers

  status: "hidden",
  visibility: "admin",

  features: {
    canCreateMaps: true,
    canViewPublicMaps: true,
    canUseTemplates: true,
    hasHistoricalData: true,
  },

  defaultMapStyle: "light",
  themeColor: "#ce1126", // Red from Syrian flag
  flagEmoji: "🇸🇾",
  thumbnailUrl: "/images/regions/syria-thumbnail.jpg",

  historicalPeriods: [
    {
      id: "ancient",
      name: "Ancient Syria",
      startYear: -3000,
      endYear: -64,
      description: "Home to ancient civilizations including Ebla and Ugarit",
    },
    {
      id: "umayyad",
      name: "Umayyad Caliphate",
      startYear: 661,
      endYear: 750,
      description: "Damascus as the capital of the Umayyad Caliphate",
    },
    {
      id: "ottoman",
      name: "Ottoman Period",
      startYear: 1516,
      endYear: 1918,
      description: "Syria under Ottoman rule",
    },
    {
      id: "french-mandate",
      name: "French Mandate",
      startYear: 1920,
      endYear: 1946,
      description: "French administration after World War I",
    },
    {
      id: "modern",
      name: "Modern Syria",
      startYear: 1946,
      endYear: undefined,
      description: "Independent Syrian Arab Republic",
    },
  ],

  childRegions: ["region-kurdistan-syria"],

  createdAt: new Date().toISOString(),
  updatedAt: new Date().toISOString(),
  order: 3,
  tags: ["middle-east", "levant", "arab", "kurdish", "mediterranean"],
};

